var React = require('react');

function OpenSalon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"flag-r","d":"M6.25,20.829V2.25H19.839L14.494,8.129l5.345,5.879H7.661v6.82ZM7.661,12.6h8.988L12.587,8.129l4.062-4.468H7.661Z","transform":"translate(-2.25 -1.25)","fill":"currentColor","fillRule":"evenodd"}));
}

OpenSalon.defaultProps = {"id":"open_salon","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = OpenSalon;

OpenSalon.default = OpenSalon;
